import { render, staticRenderFns } from "./MusicPieceBuilder.vue?vue&type=template&id=8d5fc6f2&scoped=true&"
import script from "./MusicPieceBuilder.vue?vue&type=script&lang=js&"
export * from "./MusicPieceBuilder.vue?vue&type=script&lang=js&"
import style0 from "./MusicPieceBuilder.vue?vue&type=style&index=0&id=8d5fc6f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5fc6f2",
  null
  
)

export default component.exports